import React, { useState, useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import OrderDetailInfoTable from './OrderDetailInfoTable';
import { GetOrderArticleInfoForOrderDetailInfoTable, GetOrderPaletInfoForOrderDetailInfoTable, getTotalQuantityOfBOMInMaterials } from '../../../Helpers/OrderInfoHelper'
import OrderDetailToleranceInfoTable from './OrderDetailToleranceInfoTable';
import BOLImagesComponent from '../BOLImagesComponent';
import PercentagePieChart from '../PercentagePieChart';
import { dataService } from '../../../Services/data.service';
import { systemParameters } from '../../../Config/constants';
import Box from '@mui/material/Box';

export default function OrderDetailMainInfo(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [percentage, setPercentage] = useState(props.productionOrder.switchPercentage || 0);

    // Calculate currentSilo for visibility check
    let currentSilo = null;
    if (props.general.systemParameters !== undefined && props.general.systemParameters !== null) {
        const silos = JSON.parse(props.general.systemParameters.find(x => x.id === systemParameters.Silos).value).silos.map(x => ({ label: x.name, value: x.id }));
        currentSilo = silos.find(s => s.value == props.productionOrder.defaultSilo);
    }

    // Update local state when prop changes
    useEffect(() => {
        setPercentage(props.productionOrder.switchPercentage || 0);
    }, [props.productionOrder.switchPercentage]);

    const handlePercentageChange = (newPercentage) => {
        // Optimistically update the UI
        setPercentage(newPercentage);
        
        // Save to backend using the switchRawMaterial endpoint
        // hasReplacementMaterial is true when changing percentage (not resetting)
        dataService.switchRawMaterialForOrder(
            props.productionOrder.orderLineId,
            Math.round(newPercentage),
            true
        ).then(() => {
            toast.success('Percentage succesvol opgeslagen', { position: "top-center" });
            setTimeout(() => { 
                if (props.refreshOrder) {
                    props.refreshOrder(); 
                }
            }, 1000);
        }).catch((error) => {
            // Revert on error
            setPercentage(props.productionOrder.switchPercentage || 0);
            toast.error('Fout bij opslaan percentage: ' + error, { position: "top-center" });
        });
    };

    return <Box sx={{ display: "flex", height: "auto", borderRadius: "6px", marginTop: "10px", marginRight: "35px", flexDirection: { xs: 'column' }, paddingBottom: "10px" }}>
        <Box className={classes.upperContainer} sx={{ width: "100%", paddingTop: '20px', paddingLeft: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
            <div style={{ position: 'relative', display: 'flex', flexDirection: 'column' }}>
                <div style={{ width: "100%", display: 'flex', justifyContent: 'space-between', flexDirection: 'column' }}>
                    <div className={classes.client}>
                        {t("Client")}
                    </div>

                    <div className={classes.info}>
                        <div className={classes.customer}>
                            {props.productionOrder.customerName}
                        </div>
                        <div className={classes.quantity}>
                            {"Totaal gewicht:  " + String(parseInt(getTotalQuantityOfBOMInMaterials(props.productionOrder))) + "kg"}
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", float: "left", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <BOLImagesComponent bolMetaData={JSON.parse(props.productionOrder.bolMetaData).find(x => x.MetaDataType === 1).MetaData}></BOLImagesComponent>
                    {props.user && currentSilo !== null && currentSilo !== undefined && (
                        <PercentagePieChart 
                            percentage={percentage} 
                            onPercentageChange={handlePercentageChange}
                            editable={props.user.isMasterOperator}
                        />
                    )}
                </div>
            </div>

            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, marginTop: '15px' }}>
                <Box sx={{ width: { xs: "100%", md: '50%' }, float: "left", paddingRight: "15px" }}>
                    <OrderDetailInfoTable rows={GetOrderArticleInfoForOrderDetailInfoTable(props.productionOrder.bomOut[0])}></OrderDetailInfoTable>
                </Box>
                <Box sx={{ width: { xs: "100%", md: '50%' }, float: "left" }}>
                    <OrderDetailInfoTable rows={GetOrderPaletInfoForOrderDetailInfoTable(props.productionOrder.bomOut[0], props.user.isAdministrator, currentSilo, props.productionOrder)}></OrderDetailInfoTable>
                </Box>
            </Box>
        </Box>
        <div className={classes.splitter}></div>
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", backgroundColor: "white", alignItems: "center", paddingTop: "20px", paddingLeft: '20px', marginTop: { xs: "10px", md: "0px" }, }}>
            <OrderDetailToleranceInfoTable bomOut={props.productionOrder.bomOut[0]} {...props}></OrderDetailToleranceInfoTable>
        </Box>
    </Box>
}

const useStyles = makeStyles({
    client: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block",
    },
    info: {
        color: "#020100",
        display: "block",
    },
    leftTable: {
        width: "50%",
        float: "left"
    },
    rightTable: {
        width: "50%",
        float: "left",
        paddingLeft: "15px",
        boxSizing: "border-box"
    },
    main: {
        backgroundColor: "white",
        borderRadius: "5px"
    },
    upperContainer: {
    },
    lowerContainer: {
        height: "130px",
        padding: "20px",
        paddingTop: "5px"
    },
    splitter: {
        height: "1px",
        marginLeft: "20px",
        marginRight: "20px",
        backgroundColor: "#EFEFEF"
    },
    quantity: {
        float: "right",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',

    },
    customer: {
        float: "left",
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
    }

});